import BaseApi from './baseApi'
import storeId from './_storeId'

export default class PaymentSetting extends BaseApi {
  uri = `/api/v1/stores/${storeId()}/payment-setting`
}
